import { Observable, of } from 'rxjs'
import { CanvasService } from '../canvas.service'
import { CanvasArgs, CanvasBaseCommand, CanvasCommandType } from './canvas-command.model'

export interface RedoDiagramArgs extends CanvasArgs {
  /** Client-side delegate that performs the redo on the diagram. */
  action?: () => void
}

export class RedoDiagramCommand extends CanvasBaseCommand<RedoDiagramArgs> {
  readonly id = 'redo'
  readonly type: CanvasCommandType = 'invoker'
  override icon = 'redo'
  override label = 'Redo'
  override tooltip = 'Redo (Ctrl+Shift+Z)'

  constructor(canvasService: CanvasService) {
    super(canvasService)
  }

  override enabled(args?: RedoDiagramArgs): boolean {
    return !!args?.canvasId && !!args?.canRedo
  }

  protected doExecute(args?: RedoDiagramArgs): Observable<boolean> {
    args?.action?.()
    return of(true)
  }
}
